import { collectionsData } from "../../data/data";

export const randomiseArray = (array) => {
    array = array
        .map(value => ({ value, sort: Math.random() }))
        .sort((a, b) => a.sort - b.sort)
        .map(({ value }) => value);

    return array;
}

export const getRandomisedNames = () => {
    let names = collectionsData.map(collection => collection.name);
    names = names.map(name => name.toUpperCase());
    return randomiseArray(names);
}

export const getRandomisedPrints = () => {
    let gallery = [];
    collectionsData.forEach((collection) => {
        gallery.push(...collection.items);
    });
    return randomiseArray(gallery);
}